export default __webpack_public_path__ + "static/media/Black_arrow.2a8dc243.svg";